import axios from "axios";

const COMPANY_API_HOST = process.env.REACT_APP_API_COMPANY_URL;

const axiosRestaurantInstance = axios.create({
  baseURL: COMPANY_API_HOST,
  timeout: 30000,
});

export default axiosRestaurantInstance;
